module.exports = __webpack_public_path__ + "static/media/alert.23694401.ogg";